<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UzE8hk/tc-custom/9781467467070.jpg?1728851752580" alt="This image is the cover for the book This Is Going to Hurt"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">This Is Going to Hurt
      </h1>
      <p class="bookDescription body article font2">
        <b>“If you see me at a party and I’m speaking, you need to come rescue the person I’m talking to, because they are not having a good time. Or better yet, I would like to invite you, the reader, into the corner with me to talk about the story I write over and over again: People are suffering.” </b><br/>  <br/> In her career as a journalist, Bekah McNeel has encountered (and written about) a lot of suffering. After all, the most polarizing topics in US politics all revolve around suffering. But when confronted with these stories of suffering, many people respond not with action, but by offering counterstories that justify their lack of compassion. <br/>  <br/> This set Bekah wondering: Whose suffering do we try to alleviate? Whose do we ignore? And how should our faith guide how we approach these debates? <br/>  <br/> In <i>This Is Going to Hurt</i>, Bekah analyzes the narratives surrounding six hot-button issues—immigration, COVID, abortion, critical race theory, gun violence, and climate change. For each topic, she exposes how “us versus them” thinking leads us to turn a blind eye to injustice. She also offers an alternative perspective on each issue, based on a sensitive reading of the gospel. <br/>  <br/> Amid culture wars that goad us to take up arms, Bekah reminds us that Christ calls us to take up our cross. Humorous and insightful, <i>This Is Going to Hurt</i> offers a breath of fresh air for readers seeking a nuanced and authentically Christian mode of political engagement.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bekah McNeel, Frank Schaeffer
      </h2>
      
      <p class="authorDescription body article"><P><B>Bekah McNeel </B>is a journalist and the author of <I>Bringing Up Kids When Church Lets You Down</I>. Her work has appeared in<I>&#160;Texas Monthly</I>, <I>The Guardian</I>,<I></I><I>Christianity Today</I>,<I> Sojourners</I>, <I>Relevant</I>, <I>The Texas Tribune</I>,<I></I>ESPN&rsquo;s <I>Andscape</I>,<I> The Christian Science Monitor</I>,<I> Texas Public Radio</I>, and elsewhere. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6938fe55